<template>
		<div class="home-page">
		<Header ref="childRef"></Header>
      <div class="chances-top disflex crfff ac">
        <div @click="back">
          <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
          <div>{{$t('Back')}}</div>
        </div>
      </div>
      <div class="mission-content ac crfff">
        <div class="fs50 mt50">{{$t('ChangeHairstyle')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('ChangeHairstyle_content_1')}}</div>
          </div>
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('ChangeHairstyle_content_2')}}</div>
          </div>

          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content">
              <input type="file" @change="convertToBase64_v2" class="file" accept="image/*" mutiple="mutiple">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:80%;" v-if="imageBase64" :src="imageBase64" />
                  <div class="" v-else>
                    <img width="40" src="../../static/images/transparent.png">
                    <div class="label"> {{$t('Upload')}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fs40 mt50">{{$t('petTitle2')}}<img width="20" class="ml10" src="../../static/images/pet.png" /></div>
          <div class="quan table mt20">
            <span @click="getSex" :class="{'active':isSex}"><img width="16" src="../../static/images/nv.png" />{{$t('Female')}}</span>
            <span @click="getSex" :class="{'active':!isSex}"><img width="16" src="../../static/images/nan.png" />{{$t('Male')}}</span>
          </div>
          <div class="ul hair-ul" v-if="isSex">
            <div class="li" style="width: calc(20% - 20px);" :class="{'active':isType==item.key}" v-for="(item,index) in petList" @click="getClick(item)">
              <img v-if="isType==item.key" class="dui" src="../../static/images/dui.png">
              <img class="img" :src="'../../static/images/hair-'+(index)+'.png'" />
              <div class="name">{{item.title}}</div>
            </div>
          </div>
          <div class="ul hair-ul" v-else>
            <div class="li" style="width: calc(20% - 20px);" :class="{'active':isType==item.key}" v-for="(item,index) in manList" @click="getClick(item)">
              <img v-if="isType==item.key" class="dui" src="../../static/images/dui.png">
              <img class="img" :src="'../../static/images/hair-man-'+(index+1)+'.png'" />
              <div class="name">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ac mt30">
        <button style="width: calc(100% - 100px);" @click="uploadImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
      <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
        <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
        <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>
      </div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal" slot="mdBox" >
          <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
          <div class="image ac" v-if="imageShow">
            <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{$t('downTips1')}}</div>
            <img v-if="isShowResult==1" :src="detail.url" style="width:80%;border: 1px solid #7827d3;border-radius: 20px;" />
            <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;border: 1px solid #7827d3;border-radius: 20px;" />

            <div class="tab mt50">
              <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{$t('Result')}}</span>
              <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{$t('Original')}}</span>
            </div>
            <div class="img-tools">
              <div class="ac disflex mt30">
                <div class="input-item">
                  <div class="input-item2" v-if="isShowResult==1">
                    <input class="input" disabled v-model="detail.url"  type="" placeholder="">
                    <img id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url" style="margin-left: 10px;width: 1rem" src="../../static/images/Copy.png" />
                  </div>
                  <div class="input-item2" v-if="isShowResult==2">
                    <input class="input" disabled v-model="detail.original_url"  type="" placeholder="">
                    <img id="copycode" :data-clipboard-text="detail.original_url" @click="copy" v-if="detail.original_url" style="margin-left: 10px;width: 1rem" src="../../static/images/Copy.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog ref="processDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal ac" slot="mdBox" >
          <div class="close" @click="closeProcessDialog" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;">
            <img width="70" src="../../static/images/close.png" />
          </div>
          <div class="fs33 mt50 ac">{{processMsg}}</div>
          <button class="button mt30" @click="closeProcessDialog">{{$t('OK')}}</button>
        </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			detail:{},
			isShow:false,
			value:50,
			imageShow:false,
			imageBase64: null,
			imageTpye:'',
			withScratch:false,
			isImgModel:false,
			isImage:true,
      score:0,
      isType:'',
      isSex:true,
      petList:[
        {'title':'style 1','key':'0'},
        {'title':'style 2','key':'1'},
        {'title':'style 3','key':'2'},
        {'title':'style 4','key':'3'},
        {'title':'style 5','key':'4'},
        {'title':'style 6','key':'5'},
        {'title':'style 7','key':'6'},
        {'title':'style 8','key':'7'},
        {'title':'style 9','key':'8'},
        {'title':'style 10','key':'9'},
        {'title':'style 11','key':'10'},
        {'title':'style 12','key':'11'},
        {'title':'style 13','key':'12'},
        {'title':'style 14','key':'13'},
        {'title':'style 15','key':'14'},
        {'title':'style 16','key':'15'},
        {'title':'style 17','key':'17'},
        ],
      manList:[
        {'title':'style 1','key':'mail_0'},
        {'title':'style 2','key':'mail_1'},
        {'title':'style 3','key':'mail_2'},
        {'title':'style 4','key':'mail_3'},
        {'title':'style 5','key':'mail_4'},
        {'title':'style 6','key':'mail_5'},
        {'title':'style 7','key':'mail_6'},
        ],
      isShowHeader:true,
      isShowResult:1,
      processMsg:"",
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	  created(){
		this.getHome();
	},
  methods: {
    getResult(type){
      this.isShowResult = type
    },
    getSex(){
      this.isSex = !this.isSex
      this.isType = ''
    },
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getClick(item){
      this.isType = item.key
    },
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
         // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that =this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let { width, height } = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if(!that.isType){
        that.$utils.alertText(that.$t('petTitle2'),100);
        return;
      }else if(!that.imageBase64){
        that.$utils.alertText(that.$t('uploadTips'),100);
        return;
      }
      let data ={
        image:{
          type:that.imageTpye,
          content:that.imageBase64
        },
        style:that.isType
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/change_hairstyle',data,r =>{
        if(r.code==0){
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,100);
          return;
        }
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage(){
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    },
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    },
    closeProcessDialog(){
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/changeHairstyle.vue